import { SEARCHFILTER_INIT_LOADING, SEARCHFILTER_INIT_SUCCESS, SEARCHFILTER_INIT_FAIL } from '@/store/types'

export const searchFilter = {
  [SEARCHFILTER_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [SEARCHFILTER_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [SEARCHFILTER_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}
